import { render, staticRenderFns } from "./AreaDetail.vue?vue&type=template&id=5ffab6c8&"
import script from "./AreaDetail.vue?vue&type=script&lang=js&"
export * from "./AreaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports